"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebsocketHelper = void 0;
class WebsocketHelper {
    static listenForWS() {
        if (this.unsubscribeWS) {
            return;
        }
        this.unsubscribeWS = this.wsService.listenForMessage('bot-test', (status) => {
            console.log('Received bot-test status change message:', status, status.data.botTestId, this.botTestId);
            if (status.data.botTestId === this.botTestId) {
                this.loadBotTest();
            }
        }, `bot-test-status`);
    }
    static listenForMessagesInWS() {
        if (this.unsubscribeMsgWS) {
            return;
        }
        this.unsubscribeMsgWS = this.wsService.listenForMessage('bot-test', (message) => {
            if (message.data.botTestId === this.botTestId) {
                this.loadBotTest();
            }
        }, `bot-test-message`);
    }
}
exports.WebsocketHelper = WebsocketHelper;
